import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { hireOrders, type HireOrder } from '@/api/hr';
import DataTable, { type ColumnDef } from '@/shared/components/DataTable';

const fmt2 = (v: string | number) =>
  Number(v).toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function HireOrdersPage() {
  const navigate = useNavigate();
  const list = useQuery({
    queryKey: ['hire-orders'],
    queryFn: () => hireOrders.list({ limit: 200 }),
  });

  const cols = useMemo<ColumnDef<HireOrder>[]>(() => [
    { key: 'document_number', header: '№', width: 130, importBadge: true, sortValue: (r) => r.document_number ?? '', cell: (r) => r.document_number },
    { key: 'document_date', header: 'Дата', width: 160, sortValue: (r) => r.document_date ?? '', cell: (r) => r.document_date ? new Date(r.document_date).toLocaleDateString('uk-UA') : '' },
    { key: 'hire_date', header: 'Прийняти з', width: 130, sortValue: (r) => r.hire_date ?? '', cell: (r) => r.hire_date ? new Date(r.hire_date).toLocaleDateString('uk-UA') : '' },
    { key: 'salary_amount', header: 'Оклад', width: 130, align: 'right', sortValue: (r) => Number(r.salary_amount), cell: (r) => fmt2(r.salary_amount) },
    { key: 'posted', header: 'Проведено', width: 120, align: 'center', sortValue: (r) => r.posted ? 1 : 0, cell: (r) => r.posted ? '✓ так' : 'ні' },
  ], []);

  return (
    <>
      <div className="toolbar">
        <h2 style={{ margin: 0 }}>Накази про прийом на роботу</h2>
        {/* Створення наказу = створення працівника (Трудовий) — наказ виникає
            одразу. Тому «Новий наказ» веде на єдину форму створення працівника.
            HireOrderEditor лишається для перегляду/редагування існуючих. */}
        <button className="primary" onClick={() => navigate('/employees/new-unified')}>
          + Новий наказ
        </button>
      </div>
      <DataTable<HireOrder>
        rows={list.data?.items ?? []}
        columns={cols}
        rowKey={(r) => r.id}
        loading={list.isLoading}
        emptyText="Немає документів."
        onRowDoubleClick={(r) => navigate(`/hire-orders/${r.id}`)}
        rowMuted={(r) => r.deletion_mark ? 0.4 : undefined}
        initialSortKey="document_date"
        initialSortDir="desc"
      />
    </>
  );
}
